/**
 * The campaign builder's test banner (`campaign.testBanner`). Its own file because en.ts is at
 * the size ratchet (PREC-4790 review r2 N1 added `noLead`).
 */
export const enCampaignTestBanner = {
	title: "Test your message before sending it out",
	info: 'AI snippets generate per-lead content at send time. Finalise your message first, then create snippets to see how they resolve. "Send as test" sends the full message to your inbox using a real lead.',
	sendAsTest: "Send as test",
	sendAsTestStandard: "Send as test (standard)",
	sendAsTestPremium: "Send as test (premium)",
	createAiSnippets: "Create AI snippets",
	noLead: "This list has no leads yet, so a test message cannot be rendered.",
};
